import Container from "@mui/material/Container";
import styled from "styled-components";

interface StyledInputContainerProps {
  isMobile?: boolean;
}

export const StyledInputContainer = styled(
  Container
)<StyledInputContainerProps>`
  padding-top: 50px;
  padding-bottom: 70px;
  ${(props) =>
    !props.isMobile &&
    `
    min-width: 800px;
    max-width: 800px;
  `}
`;
